<button
  type="button"
  (click)="onClick()"
  class="tw-w-full tw-border tw-border-transparent tw-transition-all"
  [ngClass]="buttonClass"
  [style.background-color]="isActive ? activeBg : null"
>
  {{ label }}
</button>
